import { z } from 'zod';
import { GYM_MODULE_KEYS } from '@bulk/types';

export const gymModulesSchema = z.object({
  disabled: z.array(z.enum(GYM_MODULE_KEYS)).describe('The modules Bulk switched off for this gym'),
  effective: z.array(z.enum(GYM_MODULE_KEYS)).describe('Everything that is off, including modules that need one that is off'),
});
export type GymModulesDto = z.infer<typeof gymModulesSchema>;

export const setGymModulesSchema = z.object({
  disabled: z.array(z.enum(GYM_MODULE_KEYS)).max(GYM_MODULE_KEYS.length).describe('Every module to switch off; every other module is on'),
});
export type SetGymModulesInput = z.infer<typeof setGymModulesSchema>;
